var _defs, _path, _path2, _rect, _text, _path3, _path4, _text2, _rect2, _br, _br2, _br3, _br4, _text3, _path5, _path6, _text4, _rect3, _br5, _br6, _br7, _br8, _text5, _path7, _path8, _text6, _rect4, _br9, _br10, _br11, _text7, _path9, _path10, _rect5, _br12, _br13, _br14, _text8, _rect6, _br15, _br16, _br17, _text9, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "759px",
    height: "631px",
    viewBox: "-0.5 -0.5 759 631",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2021-09-30T05:19:21.099Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/94.0.4606.61 Safari/537.36\" etag=\"vrl2hYeSoJ22ZkATdZPf\" version=\"15.3.8\" type=\"google\"><diagram id=\"C5RBs43oDa-KdzZeNtuy\" name=\"Page-1\">5ZnZdtowEIafhkt6vOAllwlJadKkyyFpzumdwMJWK1uOLLP06TvC8obNmpD1Cns0lqz5Zz4N0DH74XzAURzcMA/TjqF584553jEM3Tix4ENaFpnFtXqZwefEU06lYUj+YWXUlDUlHk5qjoIxKkhcN45ZFOGxqNkQ52xWd5swWl81Rj5uGIZjRJvWe+KJQO3CcEr7F0z8IF9Zt0+ykRDlzmonSYA8NquYzIuO2eeMiewqnPcxlcHL43J/ubin13/twdXP5AHdnX29/farm032eZ9Hii1wHImDpw751d1D9/cpvUPGwLKJuB4sukY29RTRVMVL7VUs8gBiD+KpbhkXAfNZhOhFaT3jLI08LJfR4K70uWYsBqMOxj9YiIVKDpQKBqZAhFSNZmvKhVY027Jh5ZewlI/xhl0qAQXiPhYb/PRCVSgHzEIs+AKe45giQab1l0MqL/3Cr4w9XKjw7yGF1iKFTeF1zyYMolDVxH5IWT7QTZZRPQUHQ4/n5SBc+fJzCNsW+VTwZtls2VhD7FJKqcssIAIPY7QM7gz40CbbFHOB5wcI1wx0PktPxUIhx3TU/awsYD2vyqBSvLZ2JG16H6JMcjxvKxPzJcvEbkhxGRFBkHywn47wUhUkcKtA12gEx1stqIgSP4LrMcQQczDIfCZwfpyqgZB4XqYfhlJDo+V8UsGYkUgst2eddazzTQWhDjf1cHmkVKVbn3hrC0X7pFmOW6uVXMSdxVCT/5CbqbiwySSBJFhVq3iHwwXUH8053Wrj3DkG/UISyQwga1IiW2fES/6tWi6jOBXZMpch9AaJVA/FIuVQuQ3v76ko3fdccxuKt8C3TupjofikTmJLb5LYaCOxrh8Lxbr1IVhs7tqyrCHE88BYb9J4iB9SHI1lAbCJbKPZVBbRe4Bxlnpra6ULOHbdOo5fPY3NI9F4yOiURD6Mn1KfcSKCcE/8bqZolbxrUk4TAVruAF4FL29xMe2bhrJbh7KjtUC596xQdt8jgp1dEfyiBG5+bewX7UrRwrwH+rrbWmGtZ7+xVth5PHztNvj2UYg52pO3t0s8TlDJ0SowtSpwWzLsUKC+ih8cer36qd3e5hotRNWsY9W1+yHaXL23K2SdF6Vs2w9AT9Em3ZAxZ4BEwRmlmO9Zsmsan429EpAc0Up3pBYvyn0ocBzLN4HZBOPSE0VeOYz5lFUG31DbZNbbJvekWeTm87ZN+hMcAE77b75rRGyXb9d0q89aS54kz6tNyXc7I4lo7cTfRAKtHhNHzSC4Lf9ayhqO8g868+I/</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 170 60 L 170 133.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 170 138.88 L 166.5 131.88 L 170 133.63 L 173.5 131.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 0,
    width: 120,
    height: 60,
    rx: 9,
    ry: 9,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 30,
      marginLeft: 111
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 21
    }
  }, "Start"))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 34,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Start")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 170 250 L 170 323.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 170 328.88 L 166.5 321.88 L 170 323.63 L 173.5 321.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 293,
      marginLeft: 169
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "Initial Cube state")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 169,
    y: 296,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Initial Cube state")))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 140,
    width: 220,
    height: 110,
    rx: 16.5,
    ry: 16.5,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 218,
      height: 1,
      paddingTop: 195,
      marginLeft: 61
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 15
    }
  }, "Determine initial Cube state", _br || (_br = /*#__PURE__*/React.createElement("br", null)), _br2 || (_br2 = /*#__PURE__*/React.createElement("br", null)), "Input: Images captured", _br3 || (_br3 = /*#__PURE__*/React.createElement("br", null)), "Output: Initial Cube state", _br4 || (_br4 = /*#__PURE__*/React.createElement("br", null))))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 199,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Determine initial Cube state...")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 170 440 L 170 513.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 170 518.88 L 166.5 511.88 L 170 513.63 L 173.5 511.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 477,
      marginLeft: 171
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "Sequence of moves")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 171,
    y: 480,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Sequence of moves")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 330,
    width: 240,
    height: 110,
    rx: 16.5,
    ry: 16.5,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 238,
      height: 1,
      paddingTop: 385,
      marginLeft: 51
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 15
    }
  }, "Solving Algorithm", _br5 || (_br5 = /*#__PURE__*/React.createElement("br", null)), _br6 || (_br6 = /*#__PURE__*/React.createElement("br", null)), "Input: Cube state", _br7 || (_br7 = /*#__PURE__*/React.createElement("br", null)), "Output: Sequence of moves that solve the Cube", _br8 || (_br8 = /*#__PURE__*/React.createElement("br", null))))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 389,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Solving Algorithm...")))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 418 192.5 L 349 192.5 L 349 195 L 286.37 195",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 281.12 195 L 288.12 191.5 L 286.37 195 L 288.12 198.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 195,
      marginLeft: 348
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "Captured Images")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 348,
    y: 198,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Captured Images")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 140,
    width: 222,
    height: 105,
    rx: 15.75,
    ry: 15.75,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 220,
      height: 1,
      paddingTop: 193,
      marginLeft: 419
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, "Camera", _br9 || (_br9 = /*#__PURE__*/React.createElement("br", null)), _br10 || (_br10 = /*#__PURE__*/React.createElement("br", null)), "Input: The face of the Cube Output: Captured Images", _br11 || (_br11 = /*#__PURE__*/React.createElement("br", null))))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 529,
    y: 196,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Camera...")))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 340 575 L 411.63 575",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 416.88 575 L 409.88 578.5 L 411.63 575 L 409.88 571.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 520,
    width: 340,
    height: 110,
    rx: 16.5,
    ry: 16.5,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 338,
      height: 1,
      paddingTop: 575,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 15
    }
  }, "Microcontroller", _br12 || (_br12 = /*#__PURE__*/React.createElement("br", null)), _br13 || (_br13 = /*#__PURE__*/React.createElement("br", null)), "Input: Sequence of moves", _br14 || (_br14 = /*#__PURE__*/React.createElement("br", null)), "Output: Signals that control the Stepper motors and the Servo motors"))))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 579,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Microcontroller...")))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 520,
    width: 340,
    height: 110,
    rx: 16.5,
    ry: 16.5,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 338,
      height: 1,
      paddingTop: 575,
      marginLeft: 419
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 17
    }
  }, "Stepper motors and Servo motors", _br15 || (_br15 = /*#__PURE__*/React.createElement("br", null)), _br16 || (_br16 = /*#__PURE__*/React.createElement("br", null)), "Input: Stepper motor control signals", _br17 || (_br17 = /*#__PURE__*/React.createElement("br", null)), "Output: Twist the Cube"))))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 588,
    y: 579,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Stepper motors and Servo motors..."))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Viewer does not support full SVG 1.1")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryImage3);
export default __webpack_public_path__ + "static/media/Gallery_Image3.c5b0c8b43fba851f58fbbbfabc076f5b.svg";
export { ForwardRef as ReactComponent };